import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

const GTAG_SCRIPT_ID = 'gtag-script';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private trackingId = environment.googleAnalyticsTrackingId;

  constructor() {
    this.initGtag();
    this.loadGtagScript();
    window.gtag!('js', new Date());
    window.gtag!('config', this.trackingId);
  }

  // Creates the dataLayer queue and the gtag stub function. This service is only
  // ever injected by post-auth pages, so this never runs on pre-auth pages.
  private initGtag(): void {
    if (window.gtag) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]) {
      window.dataLayer!.push(args);
    };
  }

  // Loads the real gtag.js script on demand. This service is only ever injected
  // by post-auth pages, so the script never loads on pre-auth pages.
  private loadGtagScript(): void {
    if (document.getElementById(GTAG_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = GTAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
    document.head.appendChild(script);
  }

  public trackPageView(url: string) {
    window.gtag!('config', this.trackingId, {
      page_path: url,
    });
  }

  public eventEmitter(eventName: string) {
    window.gtag!('event', eventName, {
      eventCategory: eventName,
    });
  }
}
